import ko from "knockout";
import _ from "lodash";
import ObservableModel from "util/ObservableModel";
import BullseyeRing from "models/BullseyeRing";

export default ObservableModel.extend(
    {
        modelProperties: {
            bullseye: ObservableModel.extend({
                modelProperties: {
                    rings: BullseyeRing,
                },
            }),
        },
        defaults: {
            name: "",
            mediaSettings: {
                chat: {
                    alertingTimeoutSeconds: 7,
                    serviceLevel: {
                        percentage: 0.8,
                        durationMs: 20000,
                    },
                },
                call: {
                    alertingTimeoutSeconds: 7,
                    serviceLevel: {
                        percentage: 0.8,
                        durationMs: 20000,
                    },
                },
            },
            acwSettings: { wrapupPrompt: null },
            bullseye: { rings: [] },
            skillEvaluationMethod: "ALL",
            callingPartyName: null,
            callingPartyNumber: null,
        },
    },
    function () {
        const self = this;

        self.name.extend({
            required: true,
            minLength: 1,
            maxLength: 64,
        });

        ko.computed(function () {
            _.last(self.bullseye().rings(), function (ring) {
                ring.actions().skillsToRemove([]);
            });
        });

        self.unwrap = function () {
            return ObservableModel.unwrap(self, [
                "errors",
                "isAnyMessageShown",
                "isValid",
                "unwrap",
            ]);
        };
    }
);
